import { IRow, TableColum } from "../../interfaces";
import { getEntries, getKeys, getValues } from "../../../../helpers/Utils";
import { validateControl } from "../../../../../core/validation/validate";

const _transformColumn = (column: TableColum) => {
	if (!column || typeof column !== "object") {
		return {};
	}

	return {
		...column,
		id: column?.field,
		type: column?.extra?.valueType || column?.type,
		contentType: column?.extra?.valueType || column?.type,
	};
};

const _transformRow = (row) =>
	getEntries(row).reduce((acc, [keyCol, valueCol]) => {
		if (keyCol !== "key" && keyCol !== "isEdit" && keyCol !== "groups") {
			acc.push({ controlid: keyCol, value: valueCol });
		}
		return acc;
	}, []);

const _transformGroup = (group = {}) =>
	getEntries(group).reduce((_acc, [keyGroup, valueGroup]) => {
		if (keyGroup !== "key") {
			_acc.push({ controlid: keyGroup, value: valueGroup });
		}
		return _acc;
	}, []);

// TODO: очень сложно - потому упростить
// DRY - mega super dry xD
export const getValidateErrors = (rows: IRow, columns: Record<string, TableColum & { groups?: [] }>) => {
	// Не знаю зачем _errors, но надо эта переменная - ммммммммутация
	let _errors;
	const validateErrors = {};

	getEntries<IRow>(rows).forEach(([keyRow, { groups, ...valueRow }]) => {
		const validateFormatRow = _transformRow(valueRow);
		const groupErrors = {};

		validateErrors[keyRow] = {};

		getEntries(columns).forEach(([keyCol, col]) => {
			if (keyCol !== "key" && keyCol !== "groups") {
				const _firstError = Array.from(
					validateControl(_transformColumn(col) as any, validateFormatRow, null, true, _errors)
				);

				if (_firstError?.[0]?.error?.message) {
					validateErrors[keyRow][keyCol] = _firstError?.[0]?.error?.message;
				}
			}
		});

		if (groups?.length) {
			groups.forEach((group, index) => {
				const validateGroupInRow = _transformGroup(group);
				groupErrors[index] = {};

				getEntries(columns.groups).forEach(([keyCol, column]) => {
					const _firstGroupError = Array.from(
						validateControl(_transformColumn(column) as any, validateGroupInRow, null, true, _errors)
					);

					if (_firstGroupError?.[0]?.error?.message) {
						groupErrors[index][keyCol] = _firstGroupError?.[0]?.error?.message;
					}
				});

				if (!getKeys(groupErrors[index]).length) {
					delete groupErrors[index];
				}
			});

			if (getKeys(groupErrors)?.length) {
				validateErrors[keyRow].groups = { ...groupErrors };
			}
		}

		if (!getValues(validateErrors[keyRow])?.filter((item) => item)?.length) {
			delete validateErrors[keyRow];
		}
	});

	return getKeys(validateErrors)?.length ? validateErrors : null;
};
